export default __webpack_public_path__ + "static/media/vinil-snow.d2fc76b4.png";